import { render, staticRenderFns } from "./AuthorizeDepositComponent.vue?vue&type=template&id=4e02fbd6&scoped=true"
import script from "./AuthorizeDepositComponent.vue?vue&type=script&lang=js"
export * from "./AuthorizeDepositComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthorizeDepositComponent.vue?vue&type=style&index=0&id=4e02fbd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e02fbd6",
  null
  
)

export default component.exports